import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import { EventCardProps } from '../types';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import useFetchWithAuth from '../../../../CommonHooks/useFetchWithAuth';
import { errorToast } from '../../../../CommonComponent/toast';
import { happeningBaseUrl } from '../../../../baseUrl';
import { HappeningType } from '../../../../globalContant';
import { noop } from 'lodash';
import { asyncNoop } from '../../../../util';

interface EventContextType {
  eventList: EventCardProps[];
  setEventList: React.Dispatch<React.SetStateAction<EventCardProps[]>>;
  setSelectedEvent: React.Dispatch<React.SetStateAction<EventCardProps>>;
  selectedEvent: EventCardProps;
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  files: File[];
  setOldFiles: React.Dispatch<React.SetStateAction<string[]>>;
  oldFiles: string[];
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  getAllEvents: () => Promise<void>;
  isNew: boolean;
  setIsNew: React.Dispatch<React.SetStateAction<boolean>>;
}

const intialData: EventContextType = {
  eventList: [],
  setEventList: noop,
  setSelectedEvent: noop,
  selectedEvent: {
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  },
  setFiles: noop,
  files: [],
  isLoading: false,
  setIsLoading: noop,
  getAllEvents: asyncNoop,
  setOldFiles: noop,
  oldFiles: [],
  isNew: false,
  setIsNew: noop,
};

const EventContext = createContext<EventContextType>(intialData);
const EventProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isNew, setIsNew] = useState<boolean>(false);
  const [eventList, setEventList] = useState<EventCardProps[]>([]);
  const [files, setFiles] = useState<File[]>([]);
  const [oldFiles, setOldFiles] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { instituteId } = useMainContainerProvider();
  const { fetchWithAuth } = useFetchWithAuth();
  const [selectedEvent, setSelectedEvent] = useState<EventCardProps>({
    title: '',
    eventDate: '',
    description: '',
    interactions: [],
  });

  const getAllEvents = async () => {
    setIsLoading(true);
    const { error, data } = await fetchWithAuth(`get-happening/?type=${HappeningType.SCHOOL_EVENT}&instituteId=${instituteId}`, {}, happeningBaseUrl);
    setIsLoading(false);
    if (error) {
      errorToast(error);
    } else {
      const updatedResult = data?.result.map((item: EventCardProps) => {
        return {
          ...item,
          interactions: typeof item.interactions === 'string' ? JSON.parse(item.interactions) : item.interactions,
        };
      });
      setEventList(updatedResult ? updatedResult : []);
    }
    // eslint-disable-next-line
  };

  useEffect(() => {
    if (!eventList.length) {
      getAllEvents();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <EventContext.Provider
      value={{
        eventList,
        setEventList,
        setSelectedEvent,
        selectedEvent,
        setFiles,
        files,
        isLoading,
        setIsLoading,
        getAllEvents,
        setOldFiles,
        oldFiles,
        isNew,
        setIsNew,
      }}
    >
      {children}
    </EventContext.Provider>
  );
};

export default EventProvider;

export const useEventProvider = () => useContext(EventContext);
